import { KTIcon } from '../../../helpers'

const Topbar = () => {
  return (
    <div className='d-flex align-items-center flex-shrink-0'>
      {/* Search 
      <Search
        className='w-lg-250px'
        mobileToggleBtnClass='btn btn-icon btn-color-gray-700 btn-active-color-primary btn-outline w-40px h-40px'
      />
    */}
      {/* begin::Activities */}
      <div className='d-flex align-items-center ms-2 ms-lg-3'>
        {/* begin::Drawer toggle */}
        {/*<div
          className='btn btn-icon btn-color-gray-700 btn-active-color-primary btn-outline rounded-pill w-50px h-50px'
          id='kt_activities_toggle'
        >
          <KTIcon iconName='notification-bing' className='fs-1' />
        </div>*/}
        {/* end::Drawer toggle */}
      </div>
      {/* end::Activities */}

      {/* CHAT */}
      <div className='d-flex align-items-center ms-2 ms-lg-3'>
        {/* begin::Drawer wrapper 
        <div
          className='btn btn-icon btn-color-gray-700 btn-active-color-primary rounded-pill btn-outline w-50px h-50px position-relative'
          id='kt_drawer_chat_toggle'
        >
          <KTIcon iconName='message-text-2' className='fs-1' />
          <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink d-none'></span>
        </div>*/}
        {/* end::Drawer wrapper */}
      </div>


    </div>
  )
}

export { Topbar }
